import { Box, TextFieldProps } from '@/primitives';

export interface HelperTextProps {
  helperText: string | Array<string> | null | undefined;
  sx?: TextFieldProps['sx'];
}

export function HelperText({ helperText, sx }: HelperTextProps) {
  if (!helperText) {
    return null;
  }

  if (Array.isArray(helperText)) {
    return (
      <Box component="ul" sx={{ listStyle: 'none', ...sx }}>
        {helperText.map((text, index) => {
          return <li key={index}>{text}</li>;
        })}
      </Box>
    );
  }

  return helperText;
}
